var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(" 付费模板-无法编辑 ")])])
}]

export { render, staticRenderFns }